// Design tokens for the messagerie - BNCB Togo mockup language.
// Imported by every messagerie component so the visual language lives in one place.
const T = {
  green: '#0A4D2E',   // sidebar / primary dark green (mockup)
  greenDark: '#083d24',   // hover / borders on green surfaces
  greenSoft: '#e8f5ed',   // light green surface (soft badges, highlights)
  accent: '#047857',   // emerald-700 - primary action buttons
  accentHover: '#059669',   // emerald-600 - button hover
  accentSoft: '#ecfdf5',   // emerald-50 - soft accent bg
  pageBg: '#f6f8fc',
  panel: '#ffffff',
  contextBg: '#f8fafc',   // slate-50 - right fiche panel
  border: '#e2e8f0',   // slate-200
  borderSoft: '#f1f5f9',   // slate-100
  text: '#1e293b',   // slate-800
  textMut: '#94a3b8',   // slate-400
  ink: '#0f172a',   // slate-900 - darker heading text
  font: "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif",
  radius: 8,
  shadowCard: '0 1px 3px rgba(15,23,42,.08)',
  shadowSm: '0 1px 2px rgba(15,23,42,.06)',
  badge: {
    unread: { bg: 'rgba(16,185,129,.18)', fg: '#a7f3d0' },
    critical: { bg: '#fee2e2', fg: '#991b1b' },
    urgent: { bg: '#fff7ed', fg: '#9a3412' },
    attention: { bg: '#fefce8', fg: '#854d0e' },
    nature: { bg: '#dcfce7', fg: '#15803d' },
    sinistre: { bg: '#ecfdf5', fg: '#065f46' },
    gray: { bg: '#f1f5f9', fg: '#475569' },
  },
};
export default T;
